/* global maskCpf, validateCpf */

function setFieldAsInvalid(field, message) {
  const { parentElement } = field;
  const errorMessageId = field.getAttribute('aria-errormessage');
  const errorElement = errorMessageId
    ? document.getElementById(errorMessageId)
    : null;

  field.setAttribute('aria-invalid', 'true');
  parentElement.classList.add('error');
  parentElement.classList.remove('success');

  if (errorElement) {
    if (message) {
      errorElement.textContent = message;
    }
    errorElement.removeAttribute('hidden');
  }
}

function setFieldAsValid(field) {
  const { parentElement } = field;
  const errorMessageId = field.getAttribute('aria-errormessage');
  const errorElement = errorMessageId
    ? document.getElementById(errorMessageId)
    : null;

  field.removeAttribute('aria-invalid');
  parentElement.classList.remove('error');
  parentElement.classList.add('success');

  if (errorElement) {
    errorElement.setAttribute('hidden', '');
  }
}

function resetFieldValidation(field) {
  const { parentElement } = field;
  const errorMessageId = field.getAttribute('aria-errormessage');
  const errorElement = errorMessageId
    ? document.getElementById(errorMessageId)
    : null;

  field.removeAttribute('aria-invalid');
  parentElement.classList.remove('error');
  parentElement.classList.remove('success');

  if (errorElement) {
    errorElement.setAttribute('hidden', '');
  }
}

function validateField(field) {
  const key = field.name || field.id;
  const value = field.value.trim();

  // Custom validation for CPF field
  if (key === 'cpf' && !validateCpf(value)) {
    setFieldAsInvalid(field);
    return false;
  }

  // Run browser validation API
  if (typeof field.checkValidity === 'function') {
    if (!field.checkValidity()) {
      setFieldAsInvalid(field, field.validationMessage);
      return false;
    }
  } else if (field.required && !value.trim()) {
    setFieldAsInvalid(field, 'This field is required.');
    return false;
  }

  setFieldAsValid(field);
  return true;
}

async function handleFormSubmit(event) {
  event.preventDefault();

  const endPoint = window.location.hostname === 'localhost'
    ? 'https://dapi.votolegal.com.br/public-api/receipt'
    : 'https://api24.doarpara.com.br/public-api/receipt';

  const form = event.target;

  if (form.hasAttribute('aria-busy') && form.getAttribute('aria-busy') === 'true') {
    return; // Prevent multiple submissions
  }

  form.classList.remove('error');
  form.classList.remove('success');

  const successFeedback = form.querySelector('[data-js="success-feedback"]');
  const errorFeedback = form.querySelector('[data-js="error-feedback"]');
  const emailList = form.querySelector('[data-js="email-list"]');
  const submitButton = form.querySelector('[data-js="submit-button"]');

  successFeedback.setAttribute('hidden', '');
  errorFeedback.setAttribute('hidden', '');

  submitButton.textContent = submitButton.getAttribute('data-pending-message') || 'Submitting...';

  let allValid = true;

  if (emailList) {
    emailList.setAttribute('hidden', '');
    emailList.innerHTML = ''; // Clear previous fromEntries
  } else {
    console.warn('Email list element not found in the form.');
  }

  const formData = new FormData(form);

  if (formData.has('cpf')) {
    const rawCpf = formData.get('cpf') || '';
    formData.set('cpf', rawCpf.replace(/\D/g, ''));
  }

  Array.from(formData.keys()).forEach((key) => {
    const field = form.elements[key];

    if (field && !validateField(field)) {
      allValid = false;
    }
  });

  if (!allValid) {
    errorFeedback.textContent = errorFeedback.getAttribute('data-default-message') || 'Please, fix the errors in the form.';
    errorFeedback.removeAttribute('hidden');

    return;
  }

  form.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch((endPoint), {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const { emails = [], message } = await response.json();

    if (emails.length && emailList) {
      const emailAddressItemTemplate = document.getElementById('email-address-item');
      const fragment = document.createDocumentFragment();

      emails.forEach((email) => {
        const emailItem = emailAddressItemTemplate.content.cloneNode(true);
        emailItem.querySelector('.email-list__item').textContent = email;
        fragment.appendChild(emailItem);
      });

      emailList.appendChild(fragment);
      emailList.removeAttribute('hidden');

      successFeedback.removeAttribute('hidden');
    } else {
      errorFeedback.textContent = message
        || errorFeedback.getAttribute('data-default-message')
        || 'No emails returned.';
      errorFeedback.removeAttribute('hidden');
    }

    form.classList.add('success');
  } catch (error) {
    console.error('Error submitting form:', error);

    form.classList.add('error');

    errorFeedback.removeAttribute('hidden');
  } finally {
    form.setAttribute('aria-busy', 'false');
    submitButton.textContent = submitButton.getAttribute('data-default-message');
  }
}

(() => {
  const form = document.querySelector('[data-js="request-receipt-form"]');

  if (!form) return;

  for (let i = 0, { length } = form.elements; i < length; i += 1) {
    const field = form.elements[i];
    if (field.type === 'text' || field.type === 'email' || field.type === 'tel') {
      field.addEventListener('input', (event) => {
        resetFieldValidation(event.target);

        if (form.classList.contains('error')) {
          form.classList.remove('error');
        }
        if (form.classList.contains('success')) {
          form.classList.remove('success');
        }
      });

      field.addEventListener('blur', (event) => {
        validateField(event.target);
      });
    }
  }

  const cpfField = form.cpf;

  if (cpfField) {
    cpfField.addEventListener('input', (event) => {
      // eslint-disable-next-line no-param-reassign
      event.target.value = maskCpf(event.target.value);
    });
  } else {
    console.warn('CPF field not found in the form.');
    return;
  }

  form.addEventListener('submit', handleFormSubmit);
})();
